export default __webpack_public_path__ + "static/media/herobackform1.3ca36571.png";